// @flow

import React from "react";
import missingThingsImage from "app/assets/missing-things.svg";
import "./MaintenancePage.scss";

const MaintenancePage = () => (
  <main className="maintenance-page">
    <div className="maintenance-page__tag">Maintenance</div>
    <h1>Site is currently under maintenance</h1>
    <p>We're performing scheduled maintenance to improve your experience.</p>
    <p>We'll be back online shortly. Thank you for your patience.</p>
    <p>
      If you have any urgent concerns, please contact the team on the
      <em>
        <a href="https://necpublishing.slack.com/archives/CPPFZV9TN">
          #prez-hub-feedback
        </a>
      </em>{" "}
      Slack channel.
    </p>
    <img src={missingThingsImage} alt="Under maintenance" />
  </main>
);

export default MaintenancePage;
